/**
 * PERSONA 5 ROYAL / JUNX SIMPLE POLICY OVERRIDE JS
 * Hijacks Shopify's default hardcoded policy layout and replaces it with a clean, minimal layout.
 */
document.addEventListener('DOMContentLoaded', () => {
  // Only execute if we are on a policy page and the default container exists
  const defaultContainer = document.querySelector('.shopify-policy__container');
  if (!defaultContainer) return;

  // 1. Extract data from Shopify's default DOM
  const titleElement = defaultContainer.querySelector('.shopify-policy__title h1');
  const bodyElement = defaultContainer.querySelector('.shopify-policy__body');
  
  if (!titleElement || !bodyElement) return;

  const policyTitle = titleElement.innerText.trim();
  const policyBodyHTML = bodyElement.innerHTML;

  // 2. Hide Shopify's default container immediately
  defaultContainer.style.display = 'none';

  // 3. Construct the clean minimal HTML
  const cleanPolicyHTML = `
    <section class="junx-simple-policy">
      <div class="junx-simple-container">
        
        <!-- Header Section -->
        <div class="junx-simple-header">
          <span class="junx-simple-tag">// ${policyTitle.toUpperCase()}</span>
          <h1 class="junx-simple-title">${policyTitle.toUpperCase()}</h1>
        </div>

        <!-- Subtle Divider -->
        <div class="junx-simple-divider"></div>

        <!-- Policy Body -->
        <div class="junx-simple-body rte">
          ${policyBodyHTML}
        </div>

      </div>
    </section>
  `;

  // 4. Inject the new HTML directly into the page
  defaultContainer.insertAdjacentHTML('afterend', cleanPolicyHTML);
  
  // 5. Cleanup the old DOM to prevent any weird layout spacing
  defaultContainer.remove();
});
